<template>
  <div id="headerTemplate">
    <b-navbar variant="light" style="width: 100%; position: fixed; z-index: 2;  height: 90px">
      <div class="container" :style="isRouteStartpage ? '' : 'max-width: 100%'" style="padding-left: 15px">
        <b-row class="pl-0" style="width: 100%">
          <b-col cols="10" sm="8" md="8" lg="8" xl="8" class="padding-left-zero-xs">
            <b-navbar-brand class="selection" @click="redirectToStartPage">
              <b-img src="../../assets/images/mayr_26.png" alt="mayr_30"/>
              {{ $t('header.productConfigurator') }}
            </b-navbar-brand>
          </b-col>

          <!-- Language -->
          <b-col cols="2" sm="4" md="4" lg="4" xl="4" class="px-custom" style="padding-right: 0px; padding-top: 8px">
            <LocaleChanger class="my-auto rm-on-xs"/>
          </b-col>
          <!-- Breadcrumb Produktauswahl -->
          <b-col cols="10" sm="10" md="10" lg="8" class="padding-left-zero-xs">
            <span class="selection text-primary pr-1" @click="redirectToStartPage">{{$t('general.productSelection')}}</span>
            <span v-if="productBreadcrumb !== ''">/ {{productBreadcrumb}}</span>
          </b-col>

          <b-col cols="2" sm="2" md="2" lg="4" style="padding-right: 0px;  margin-bottom: 5px">
            <!-- Profile -->
            <ProfileMenu v-if="!anonym" :csrf-token="csrfToken"/>

            <!-- Login -->
            <LoginModal v-if="anonym" />
            <b-button @click="$bvModal.show('bv-modal-login')" class="float-and-padding-login-button" variant="outline-primary"
                      style="white-space: nowrap" v-if="anonym">
              {{ $t('header.logIn') }}
            </b-button>

          </b-col>
        </b-row>
      </div>
    </b-navbar>
    <ConfigureProfilModal/>
    <ResetCachesModal/>
  </div>
</template>

<script>
import LoginModal from "../utils/LoginModal";
import LocaleChanger from "@/components/utils/LocaleChanger";
import ConfigureProfilModal from "@/components/utils/ConfigureProfilModal";
import ProfileMenu from "@/components/utils/ProfileMenu";
import ResetCachesModal from "@/components/utils/ResetCachesModal";
import {router} from "../../main";

export default {
  name: "HeaderTemplate",
  props: ['csrfToken', 'i18nBenennung'],
  components: {LoginModal, ResetCachesModal, ProfileMenu, ConfigureProfilModal, LocaleChanger},
  computed: {

    isTestDatabaseEnabled: function() {
      return this.$store.getters.isTestDatabaseEnabled;
    },
    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },
    isRouteStartpage: function () {
      if(this.$route.name === 'StartPage'){
        return true;
      } else {
        return false;
      }
    },
    productBreadcrumb: function () {
      let productBreadcrumb = this.$store.getters.productBreadcrumb;
      let typenschluessel;
      if(this.$store.getters.konfigModel === undefined){
        typenschluessel = undefined;
      } else {
        typenschluessel = this.$store.getters.konfigModel.typenSchluessel;
      }
      if(productBreadcrumb === undefined) {
        return '';
      } else if(productBreadcrumb != '' && this.$route.name.startsWith('ConfigPage') && typenschluessel !== undefined) {
        let crumbies = productBreadcrumb.split('/')
        return crumbies[0] + ' / ' + crumbies[1] + ' / ' + typenschluessel;
      }
      else if(productBreadcrumb != ''){
        return productBreadcrumb;
      }
      return '';
    },
  },
  methods: {
    redirectToStartPage() {
      if(this.$route.name !== 'StartPage'){
        router.push({name: 'StartPage'})
      } else {
        router.go(0);
      }
    },
  }
}

</script>
<!-- End Consentmanager -->

<style scoped>
.navbar-brand {
  color: #777;
  font-style: italic;
  font-weight: bold;
  font-size: 22px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.selection{
  cursor: pointer;
}
</style>